/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import styled from 'styled-components'
import { mobileL } from './utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const AppWrapper = styled.div`
  .main {
    padding-bottom: 50px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .companyLogoWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    z-index: 10;
    margin: 0 60px;
    padding-top: 5px;
    background: white;

    ${mobileL({
      margin: '0 ',
    })}
  }

  .companyLogo {
    margin: 10px auto 10px;
    padding-left: 20px;
  }

  .footerStyle {
    display: flex;
    justify-content: center;
    padding: 40px 0;
    font-weight: 600;
  }

  @media (min-width: 1001px) {
    .content {
      margin: 0 60px;
    }
  }

  @media (min-width: 800px) and (max-width: 1000px) {
    .content {
      margin: 0 20px;
    }
  }
`
